<template>
  <div class="yellowTips">
    存在操作场景，暂无法实现获取正确的数据操作前内容，如发现缺失或有疑问，请找开发协助排查！
  </div>
  <Tooltip trigger="click">
    <template #title>
      <p>存在以下比对差异不正确的场景：</p>
      <p>1. 单独操作涉及多条数据：操作的接口后链路修改其他页面的数据，即A功能A数据的操作，改了B、C功能的B、C数据</p>
      <p>2. 数据可以被其他页面操作修改的特殊场景：无新增操作，且无法获取主数据的编辑接口</p>
      <p>3. 针对存在批量操作的数据，单独操作产生的日志</p>
      <p>4. 接口没有记录操作内容的值</p>
    </template>
    <span class="cursor-pointer text-blue-500">
      点击，查看场景说明
    </span>
  </Tooltip>
  <div class="flex mt-4">
    <h3 class="font-medium text-sm w-6/12">
      操作前的内容：
    </h3>
    <h3 class="font-medium text-sm w-6/12">
      <Tooltip>
        <template #title>
          <p>当前操作的内容，操作后的内容只有id时，表示当前操作为删除类操作</p>
        </template>
        <InfoCircleOutlined />
      </Tooltip>
      操作后的内容：
    </h3>
  </div>
  <CodeDiff
    diff-style="char"
    :max-height="400"
    :new-string="optBody ?? props.operationBody"
    :old-string="preOptBody ?? props.preOperationBody"
    output-format="side-by-side"
  />
</template>
<script setup lang="ts">
import { isArray, isObject } from '@/utils/is'
import { type LogInfo } from '../type'
import { type Ref, ref, toRefs, watch, defineProps } from 'vue'
import {
  Tooltip,
} from 'ant-design-vue'
import { CodeDiff } from 'v-code-diff';

const props = defineProps<LogInfo>()
const { operationBody, preOperationBody } = toRefs(props)
const optBody = ref('')
const preOptBody = ref('')

const processValue = (value: string, targetStr: Ref<string>) => {
  if (value?.startsWith('{')) { // 是对象的时候，转换成key-value的形式，一行一个key，方便查看diff
    targetStr.value = '' // 重置
    const bodyObj = JSON.parse(value)
    Object.keys(bodyObj).sort()
      .forEach(key => {
        let value = ''
        if (isArray(bodyObj[key]) || isObject(bodyObj[key])) {
          value = JSON.stringify(bodyObj[key], null, 2)
        } else {
          value = String(bodyObj[key])
        }
        targetStr.value = targetStr.value + `${key}: ${value}\n`
      })
  } else {
    targetStr.value = value
  }
}

watch(
  () => operationBody.value,
  (value) => {
    processValue(value, optBody)
  },
  {
    immediate: true,
  },
)

watch(
  () => preOperationBody.value,
  (value) => {
    processValue(value, preOptBody)
  },
  {
    immediate: true,
  },
)
</script>
<style lang="less">
.yellowTips {
  color: #faad14;
}

.fs-custom-modal {
  .code-diff-view {
    .file-header {
      display: none;
    }

    .diff-table {
      .blob-code-marker::before {
        content: none;
      }
    }
  }
}
</style>
